import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { parseISO, format } from 'date-fns';

import { Tabela } from '~/components';
import { t, number } from '~/helpers';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/operacaoBateriaDbic/actions';

import MyForm from './form';

function OperacaoBateriaDbic() {
  const data = useSelector((state) => state.operacaoBateriaDbic);
  const header = useMemo(
    () => [
      {
        id: 'codigonomeposto',
        label: t('s.geral.alertasistema.nomeabreviadoposto'),
        filter: { type: 'text' },
      },
      {
        id: 'idterminal',
        label: t('s.configuracao.terminal.idterminal'),
        filter: { type: 'text' },
      },
      {
        id: 'idbico',
        label: t('s.configuracao.bico.idbico'),
        filter: { type: 'text' },
      },
      {
        id: 'ultimatrocabateriadbic',
        label: t('labelsistema.ultimatrocabateriadbic'),
        format: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'diasduracaobateriadbic',
        label: t('labelsistema.diasduracaobateriadbic'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'tensaoiniciologtrocabateriadbic',
        label: t('labelsistema.tensaoiniciologtrocabateriadbic'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'tensaofimlogtrocabateriadbic',
        label: t('labelsistema.tensaofimlogtrocabateriadbic'),
        align: 'right',
        format: (value) => number(value, 1),
      },
    ],
    []
  );

  return (
    <Tabela
      read={dataInRequest}
      remove={deleteData}
      state={data}
      header={header}
      headerMobile="codigonomeposto"
      unique={['idbico']}
      form={MyForm}
      findItem={findData}
      recordFilter={recordFiltering}
    />
  );
}

export default OperacaoBateriaDbic;
